// 新版用户体系(V3)
import Vue from 'vue'
const _vm = new Vue()
const MODULE = '/customer/api/v3/'

// 用户体系相关字典(广告主类型:ADVERTISER_TYPE 客户类型:CUSTOMER_TYPE 审核状态:CHECK_STATUS
// 账户状态:ACCOUNT_STATE 账户类型:ACCOUNT_TYPE 会员等级列表:MEMBER_TYPE 企业认证类型:COMPANY_TYPE)
export const customerDic = p => _vm.fetch(MODULE + 'dic/' + p, '', 'GET')

// 登录注册
// 获取RSA加密公钥
export const publickKey = () => _vm.fetch(MODULE + 'public-key', '', 'GET')
// 获取短信验证码
export const getVerifyCode = p => _vm.fetch(MODULE + 'sms/verify-code', p, 'GET')
// 手机号密码登录
export const pwdLogin = p => _vm.fetch(MODULE + 'login', p, 'POST')
// 用户注册
export const registUser = p => _vm.fetch(MODULE + 'user', p, 'POST')
// 根据id获取用户数据
export const userById = id => _vm.fetch(MODULE + 'user/' + id, '', 'GET')
// 根据id获取密码和支付密码
export const userPassword = id => _vm.fetch(MODULE + 'user/' + id + '/password', '', 'GET')

// 当前登录用户点位投放可用的tab选项
export const putTabsForUser = id => _vm.fetch(`${MODULE}user/${id}/tab`, '', 'GET')

// 当前登录用户点位投放可用的收费方式
export const chargeTypesForUser = id => _vm.fetch(`${MODULE}user/${id}/chargeType`, '', 'GET')

// 根据id获取客户详情数据
export const customerById = id => _vm.fetch(MODULE + 'customer/' + id, '', 'GET')

// 新建客户
export const createCustomer = p => _vm.fetch(MODULE + 'customer', p, 'POST')
// 更新客户资料(重新提交)
export const updateCustomer = p => _vm.fetch(MODULE + 'customer', p, 'PUT')

// 获取用户账户信息(总余额、现金/赠款账户余额)
export const accBalance = id => _vm.fetch(MODULE + 'user/' + id + '/accounts', '', 'GET')

//指定账户流水
export const getBill = p => _vm.fetch('billing/api/v3/capital-flows-gather', p, 'GET')
//流水详情
export const getDetail = p => _vm.fetch('billing/api/v3/capital-flows-gather/page', p, 'GET')

// 修改手机号
// 获取旧手机允许修改令牌
export const updateToken = (id, p) => _vm.fetch(MODULE + 'user/' + id + '/update-token', p, 'GET')
// 换绑手机
export const modifyPhone = p => _vm.fetch(MODULE + 'user/phone', p, 'PATCH')

// 用户密码相关
// 修改登录密码
export const modifyLoginPwd = p => _vm.fetch(MODULE + 'user/password', p, 'PUT')
// 忘记密码(找回/重置密码)
export const resetPwd = p => _vm.fetch(MODULE + 'user/password/reset', p, 'PUT')
// 创建/修改账户支付密码
export const modifyPayPwd = p => _vm.fetch(MODULE + 'user/pay-password', p, 'PUT')
